import { LazyLoadImage } from 'react-lazy-load-image-component';
import { s3Link } from '../../utils/constants';

import './style.scss';
const CoverPic = ({ user }) => {
    return <div className={`cover-pic${!user.cover_pic ? ' no-cover' : ''}`}>
        {
            user.cover_pic
                ? <LazyLoadImage
                    src={`${s3Link}/${user.id}/cover_photo.jpg?t=${user.cover_photo_updated_at}`}
                    className='cover-pic__image'
                />
                : null
        }
    </div>;
};

export default CoverPic;